export default "__VITE_ASSET__CYeNvHRE__"